module.exports = __webpack_public_path__ + "static/media/forgot_password.125c872c.png";